import React from "react";

const SEVERITY_STYLES = {
  error: {
    container: "border-red-200 bg-red-50 text-red-800",
    icon: "text-red-600",
  },
  success: {
    container: "border-green-200 bg-green-50 text-green-800",
    icon: "text-green-600",
  },
};

function AlertIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
    </svg>
  );
}

function SuccessIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  );
}

/**
 * Inline alert for auth/forms — Tailwind-only so icon sizing is stable in production
 * (MUI Alert depends on Emotion styles that may not apply in prod builds).
 */
export default function InlineAlert({ severity = "error", children, className = "" }) {
  const styles = SEVERITY_STYLES[severity] ?? SEVERITY_STYLES.error;
  const Icon = severity === "success" ? SuccessIcon : AlertIcon;

  return (
    <div
      role="alert"
      className={`flex items-center gap-2.5 rounded-md border px-3 py-2.5 text-sm leading-5 ${styles.container} ${className}`}
    >
      <Icon className={`h-5 w-5 shrink-0 ${styles.icon}`} />
      <span className="min-w-0 flex-1">{children}</span>
    </div>
  );
}
